import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import SimpleOptionCard from './SimpleOptionCard';
import {
  AccordionGroup,
  AccordionContent,
} from 'core/controls/accordion/Accordion';
import OptionsGrid from '../optionsGrid/OptionsGrid';
import OptionsAccordionHeader from './OptionsAccordionHeader';

const SimpleOptionGroup = ({
  header,
  options,
  analyticsKey,
  analyticsKey2,
  id,
  isOpenDefault,
  displayOnly,
  onChange,
  onDetails,
  isUpdating,
  selectingOption,
}) => {
  const count = options.length;

  if (count === 0) {
    return null;
  }

  const optionList = options.map((option) => (
    <SimpleOptionCard
      key={option.code}
      option={option}
      onChange={onChange}
      onDetails={onDetails}
      analyticsKey={analyticsKey}
      analyticsKey2={
        isFunction(analyticsKey2) ? analyticsKey2(option) : option.description
      }
      isUpdating={isUpdating}
      selectingOption={selectingOption}
      checked={option.selected}
      displayOnly={option.alwaysSelected || false}
    />
  ));

  return (
    <AccordionGroup
      key={header}
      id={id}
      isOpenDefault={isOpenDefault}
      displayOnly={displayOnly}
      className="accordion-item--simple-option">
      <OptionsAccordionHeader
        className="accordion-title--simple-option"
        header={header}
        count={count}
        analyticsKey="right rail"
      />
      <AccordionContent className="accordion-content--simple-option">
        <OptionsGrid role="radiogroup" analyticsKey={header}>
          {optionList}
        </OptionsGrid>
      </AccordionContent>
    </AccordionGroup>
  );
};

SimpleOptionGroup.defaultProps = {
  isOpenDefault: false,
  displayOnly: false,
  isUpdating: false,
  selectingOptionCode: '',
};

SimpleOptionGroup.propTypes = {
  isOpenDefault: PropTypes.bool,
  displayOnly: PropTypes.bool,
  isUpdating: PropTypes.bool,
  selectingOptionCode: PropTypes.string,
};

export default SimpleOptionGroup;
